import $ from 'jquery';

function passwordStrengthValidator(
    $el /* jQuery element to validate */,
    required /* is the element required according to the `[required]` attribute */,
    parent /* parent of the jQuery element `$el` */
) {
    if (!required) return true;
    var password = $el.val();
    let regex = new RegExp(
        /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{7,}$/
    );
    return regex.test(password);
}

function passwordsMatch(
    $el /* jQuery element to validate */,
    required /* is the element required according to the `[required]` attribute */,
    parent /* parent of the jQuery element `$el` */
) {
    if (!required) return true;
    var prevPass = $(".SELECT_PASSWORD").val();
    var password = $el.val();
    if (prevPass === password) {
        return true;
    } else {
        return false;
    }
}

// Set default options
Foundation.Abide.defaults.validators[
    "password_check"
] = passwordStrengthValidator;
Foundation.Abide.defaults.validators["passwords_match"] = passwordsMatch;
